import type { AttachmentId } from '../../types';

import { bump, requireCache } from '../runtime';

import { attachmentOwnerKeys } from './comments';

export const THUMBNAILS_KEY = 'thumbnails';

export function setAttachmentThumbnail(args: { attachmentId: AttachmentId; url: string }): void {
  const cache = requireCache();
  const attachment = cache.attachments.get(args.attachmentId);
  if (attachment === undefined) {
    throw new Error('Вложение не найдено');
  }
  cache.attachmentThumbnails.set(args.attachmentId, {
    attachmentId: args.attachmentId,
    url: args.url,
    createdAt: cache.nowMs(),
  });
  bump(THUMBNAILS_KEY, ...attachmentOwnerKeys(cache, attachment, undefined));
}
